<template>
  <AppStateQuotation
    v-if="!_loading"
    :quotation="modelData"
    ref="AppStateQuotation"
    @save="$_onSave($event)"
  >
  </AppStateQuotation>
</template>

<script>
export default {
  data: () => ({
    modelName: "quotation",
    modelData: null,
  }),
  methods: {
    async $_onSave($event) {
      this.$refs.AppStateQuotation.submitLoadingStart();
      try {
        await this.$axios.patch(`${this.modelName}/${this._id}`, $event);
        this.$router.push(`/${this.modelName}`);
      } catch (error) {
        alert("儲存錯誤");
      } finally {
        this.$refs.AppStateQuotation.submitLoadingStop();
      }
    },
    async $_fetchModel() {
      try {
        this.$store.dispatch("app/startPageLoading");
        const res = await this.$axios.get(`${this.modelName}/${this._id}`);
        this.modelData = res.data.data;
      } catch (error) {
        alert("取得評估錯誤");
      } finally {
        this.$store.dispatch("app/stopPageLoading");
      }
    },
  },

  mounted() {
    this.$_fetchModel();
  },

  computed: {
    _loading() {
      return this.$store.state.app.pageLoading;
    },
    _id() {
      return this.$route.params.id;
    },
  },
};
</script>

<style>
</style>